var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_3963)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31311 11.5202L1.14645 13.6869C1.05268 13.7807 1 13.9078 1 14.0404V18.4C1 18.6761 1.22386 18.9 1.5 18.9H16.5C16.7761 18.9 17 18.6761 17 18.4V14.0404C17 13.9078 16.9473 13.7807 16.8536 13.6869L12.0202 8.85355C11.825 8.65829 11.5084 8.65829 11.3131 8.85355L6.68689 13.4798C6.49162 13.675 6.17504 13.675 5.97978 13.4798L4.02022 11.5202C3.82496 11.325 3.50838 11.325 3.31311 11.5202Z",
    fill: "#7B8CC8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.5,
    r: 2,
    fill: "#7B8CC8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 17,
    rx: 1.5,
    stroke: "#7B8CC8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_3963"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentImage);
export default __webpack_public_path__ + "static/media/content-image.0868859442360f5f3b4b4cfcc412e2d4.svg";
export { ForwardRef as ReactComponent };